import React, { useState } from "react";
import { I18nextProvider, useTranslation } from "react-i18next";
// A document owns its language. Creating or closing it must not mutate the app locale.
export default function PdfLanguageProvider({ language, children }: { language?: string; children: React.ReactNode }) {
  const { i18n } = useTranslation();
  const [documentI18n] = useState(() => i18n.cloneInstance({ lng: language || i18n.language, initImmediate: false }));
  return <I18nextProvider i18n={documentI18n}>{children}</I18nextProvider>;
}
